<template>
  <base-step
    :title="trans('guided_search.duration.title')"
    :title-precision="trans('guided_search.extended_title.approximately')"
    main-class="duration-step-container"
  >
    <template #content>
      <div v-if="durationChoices" class="general-tags duration-step-container__tags">
        <TypeFormButton
          v-for="(tag, index) in durationChoices"
          :key="index"
          :content="trans(tag.key, { min: tag.value, max: tag.value * 2 })"
          :active="isTagActive(tag)"
          @clicked="selectTag(tag)"
        />
      </div>
    </template>
  </base-step>
</template>

<script>
import TypeFormButton from '@components-molecules/TypeFormButton.vue';
import { translationMixin } from '@elements/translation';
import { guidedSearchMixin } from '@pages/guided-search/guidedSearchMixin';
import { durationChoices } from '@pages/guided-search/guidedSearchEnum';
import BaseStep from './BaseStep.vue';

export default {
  name: 'Duration',
  components: { TypeFormButton, BaseStep },
  mixins: [ guidedSearchMixin, translationMixin ],
  data() {
    return {
      durationChoices,
    };
  },
  computed: {
    getStepDurationValue() {
      return this.store.stepValues.duration;
    },
  },
  mounted() {
    window.dataLayer.push({
      event: 'screenChange',
      event_name: 'duration',
      step: 'duration',
      funnel: 'support-contact-form',
    });
  },
  methods: {
    isTagActive(tag) {
      return this.getStepDurationValue && this.getStepDurationValue.value === tag.value;
    },
    selectTag(tag) {
      const previousValue = this.getStepDurationValue?.value;
      this.store.setStepValue({ step: 'duration', value: tag });
      if (previousValue !== tag.value) {
        this.$emit('next-step');
        return;
      }
      this.store.setStepValue({
        step: 'duration',
        value: null,
      });
    },
  },
};
</script>
